if (!window.Eurus.loadedScript.has("seadent-product-promotion.js")) {
  window.Eurus.loadedScript.add("seadent-product-promotion.js");

  document.addEventListener("alpine:init", () => {
    Alpine.data("xProductPromotion", (productHandle, collections) => ({
      loading: false,
      show:false,
      hasFreeGift: false,
      html: "",
      productCache: {},
      customer: null,
      selectedDeal: null,
      chooseDefaultDeal: false,
      productCollections: collections,
      isBuyXGetX: false,
      groupMessages: {},
      totalRules: 0,
      volumeRules: [],
      freeGiftRules: [],
      get rules() {
        const allRules = this._mergeAndSortRules(
          this.volumeRules,
          this.freeGiftRules
        );

        return allRules;
      },

      async init() {
        try {
          this.loading = true;
          await Promise.all([
            this._buildVolumeRules(),
            this._buildFreeGiftRules()
          ]);
          this.hasFreeGift = this.hasFreeGift || this.isBuyXGetX;
          this.show = this.rules.length > 0;
          this._buildGroupMessages();
        } catch (error) {
          console.error("Promotion Init Error:", error);
        } finally {
          this.loading = false;
        }
      },
      async _buildFreeGiftRules() {
        const allFreeGiftRules = await window.tlFreeGiftOffer.getAllRule();
        const activeFreeGiftRules =
          this._filterActiveFreeGiftRules(allFreeGiftRules);
        const hasBogoGift = activeFreeGiftRules.some(
          (rule) => rule.type === "bogo"
        );
        if(hasBogoGift) this.hasFreeGift = true
        if(activeFreeGiftRules.length > 0) this.show = true;

        this.freeGiftRules = activeFreeGiftRules;
        await this.prefetchProductDetails();
      },
      _buildGroupMessages() {
        const messages = this.buildPromotionMessages(this.rules)

        const groupMap = {}
        messages.forEach((item) => {
          if (!groupMap[item.minimumQty]) {
            groupMap[item.minimumQty] = []
          }
          groupMap[item.minimumQty].push(item)
        })

        this.groupMessages = groupMap
      },

      async _buildVolumeRules() {
        const discountData = await Promise.race([
          window.sdWaitForVolumnDiscounts(),
          new Promise((_, reject) =>
            setTimeout(() => reject("Timeout waiting for discounts"), 5000)
          ),
        ]).catch(() => ({ group: [] }));

        const { group: discountsGroup, chooseDefaultDeal } = discountData;
        if (!Array.isArray(discountsGroup) || discountsGroup.length === 0)
          return [];


        this.chooseDefaultDeal = chooseDefaultDeal;
        const rules = [];

        for (let i = 0; i < discountsGroup.length; i++) {
          const discount = discountsGroup[i];
          if (!discount?.status) continue;

          (discount.discountTiers || []).forEach((tier) => {
            const rule = this._buildVolumeRule(discount, tier);
            if (rule) {
              rules.push(rule);
              if (rule.isDefault && !this.selectedDeal) {
                this.selectedDeal = `${rule.groupId}-${rule.tierId}`;
              }
            }
          });
        }

        this.volumeRules = rules;
      },

      _buildVolumeRule(discount, tier) {
        if (!tier) return null;

        const isBuyXGetX = Boolean(tier.buy_x_get_x);
        this.isBuyXGetX = isBuyXGetX;

        if (!isBuyXGetX && !tier.off) return null;

        return {
          type: "volume",
          minimumQty: isBuyXGetX ? tier.quantity_buy : tier.minimum,
          groupId: discount.id,
          tierId: tier.id,
          isDefault: tier.selected_by_default,
          rule: {
            isBuyXGetX,
            type: discount.value_type,
            discountAmount: tier.off,
            minimumQty: tier.minimum,
            ...(isBuyXGetX && {
              quantityBuy: tier.quantity_buy,
              quantityGet: tier.quantity_get,
            }),
          },
        };
      },
      _filterActiveFreeGiftRules(rules) {
        return rules
          .filter(
            (rule) =>
              rule.active &&
              this.validateAdvancedConditions(rule) &&
              window.tlFreeGiftOffer.checkActiveDate(rule) &&
              this._isRuleApplicableToProduct(rule)
          )
          .map((rule) => ({
            type: rule.type,
            minimumQty: rule.apply_condition_value,
            rule,
          }));
      },
      _isRuleApplicableToProduct(rule) {
        if (rule.listParents.length === 0) return true;
        if (rule.apply_to_product === "collection") {
          const collectionHandles = rule.listParents.map((p) => p.handle);
          return this.productCollections.some((handle) =>
            collectionHandles.includes(handle)
          );
        }
        if (rule.apply_to_product === "product") {
          return rule.listParents.some((p) => p.handle === productHandle);
        }
        return false;
      },
      _mergeAndSortRules(volumeRules, freeGiftRules) {
        const priority = { volume: 1, bogo: 2, advanced: 3 };

        return [...volumeRules, ...freeGiftRules].sort(
          (a, b) =>
            a.minimumQty - b.minimumQty || priority[a.type] - priority[b.type]
        );
      },
      async prefetchProductDetails() {
        const activeRules = this.freeGiftRules

        const handles = [
          ...new Set(
            activeRules.flatMap(
              (rule) =>
                rule.rule?.listChilds
                  ?.map((child) => child.handle)
                  .filter(Boolean) || []
            )
          ),
        ];

        if (handles.length === 0) return this.productCache;

        const handlesToFetch = handles.filter((h) => !this.productCache[h]);
        const locale = window.Shopify?.locale || "";
        const baseUrl =
          locale && locale !== "vi" ? `/${locale}/products/` : `/products/`;

        await Promise.allSettled(
          handlesToFetch.map(async (handle) => {
            try {
              const res = await fetch(`${baseUrl}${handle}.js`);
              if (!res.ok) throw new Error();

              const product = await res.json();
              this.productCache[handle] = {
                title: product.title,
                handle: product.handle,
                image: product.images?.[0] || null,
              };
            } catch (err) {
              this.productCache[handle] = null;
            }
          })
        );

        return this.productCache;
      },
      getCustomerConditions(advancedConditionsRaw) {
        if (
          !advancedConditionsRaw ||
          typeof advancedConditionsRaw !== "string"
        ) {
          return null;
        }

        let conditions;

        try {
          conditions = JSON.parse(advancedConditionsRaw);
        } catch (e) {
          console.error("Invalid advanced_conditions JSON", e);
          return null;
        }

        const customerConditions = {
          specificCustomerIds: Array.isArray(conditions.specific_customer)
            ? conditions.specific_customer.map(String)
            : [],
          customerTagRule: conditions.customer_tag
            ? {
                type: conditions.customer_tag.type,
                tags: conditions.customer_tag.targetCustomerTag || [],
              }
            : null,

          requireLoggedIn: conditions.customer_status === "logged_in",
          requireLoggedOut: conditions.customer_status === "not_logged",

          orderCountRule: conditions.order_count ?? null,
          totalSpentRule: conditions.total_spent ?? null,
        };

        return customerConditions;
      },
      validateAdvancedConditions(rule) {
        const customer = this.customer;
        const conditions = this.getCustomerConditions(rule.advanced_conditions);
        if (!conditions) return true;
        if (conditions.requireLoggedIn && !customer) {
          return false;
        }

        if (conditions.requireLoggedOut && customer) {
          return false;
        }
        if (!customer) return true;

        if (
          Array.isArray(conditions.specificCustomerIds) &&
          conditions.specificCustomerIds.length > 0
        ) {
          const customerId = String(customer.id);
          if (!conditions.specificCustomerIds.includes(customerId)) {
            return false;
          }
        }

        if (conditions.customerTagRule) {
          const { type, tags } = conditions.customerTagRule;
          const customerTags = customer.tags || [];

          const hasMatchingTag = tags.some((tag) => customerTags.includes(tag));

          if (type === "include" && !hasMatchingTag) {
            return false;
          }

          if (type === "exclude" && hasMatchingTag) {
            return false;
          }
        }

        if (conditions.orderCountRule) {
          const { operator, value } = conditions.orderCountRule;
          const orderCount = Number(customer.orders_count || 0);

          if (!this._compareNumber(orderCount, operator, value)) {
            return false;
          }
        }

        if (conditions.totalSpentRule) {
          const { operator, value } = conditions.totalSpentRule;
          const totalSpent = Number(customer.total_spent || 0);

          if (!this._compareNumber(totalSpent, operator, value)) {
            return false;
          }
        }

        return true;
      },
      _compareNumber(actual, operator, expected) {
        switch (operator) {
          case ">":
            return actual > expected;
          case ">=":
            return actual >= expected;
          case "<":
            return actual < expected;
          case "<=":
            return actual <= expected;
          case "==":
            return actual == expected;
          case "!=":
            return actual != expected;
          default:
            console.warn("Unknown operator:", operator);
            return true;
        }
      },
      _formatMoney(amount) {
        return new Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
          minimumFractionDigits: 0,
        })
          .format(amount)
          .replace(/\s/g, "");
      },
      _getCurrentLocale() {
        if (window.Shopify?.locale) {
          return window.Shopify.locale;
        }

        const pathLocale = location.pathname.split("/")[1];
        return pathLocale && pathLocale.length === 2 ? pathLocale : null;
      },
      sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
      },
      buildPromotionMessages(sortedRules) {
        const locale = this._getCurrentLocale();
        const result = [];

        const ruleMap = {};

        sortedRules.forEach((rule) => {
          if (!ruleMap[rule.minimumQty]) {
            ruleMap[rule.minimumQty] = { volume: [], gift: [] };
          }

          rule.type === "volume"
            ? ruleMap[rule.minimumQty].volume.push(rule)
            : ruleMap[rule.minimumQty].gift.push(rule);
        });

        for (const minimumQty in ruleMap) {
          const { volume, gift } = ruleMap[minimumQty];
          const hasMultipleVolume = volume.length > 1;

          if (volume.length > 0) {
            volume.forEach((volumeRule, index) => {
              const parts = [];

              if (volumeRule.rule.isBuyXGetX) {
                parts.push(`tặng ${volumeRule.rule.quantityGet}`);
              } else {
                parts.push(
                  volumeRule.rule.type === "fixed"
                    ? `giảm ngay ${this._formatMoney(
                        volumeRule.rule.discountAmount
                      )}`
                    : `giảm ngay ${volumeRule.rule.discountAmount}%`
                );
              }

              gift.forEach((giftRule) => {
                this._appendGiftParts(parts, giftRule, locale);
              });

              result.push({
                groupId: volumeRule.groupId,
                tierId: volumeRule.tierId,
                minimumQty,
                hasVolume: true,
                multipleVolume: hasMultipleVolume,
                text: `Ưu đãi mua ${minimumQty} ${parts.join(" + ")}`,
              });
            });

            continue;
          }

          if (gift.length > 0) {
            const parts = [];
            gift.forEach((g) => this._appendGiftParts(parts, g, locale));

            result.push({
              key: `qty-${minimumQty}-gift`,
              minimumQty,
              hasVolume: false,
              multipleVolume: false,
              text: `Ưu đãi mua ${minimumQty} ${parts.join(" + ")}`,
            });
            
          }
        }

        return result;
      },
      _appendGiftParts(parts, giftRule, locale) {
        if (
          giftRule.type === "bogo" &&
          giftRule.rule.discount_type === "percentage"
        ) {
          parts.push(`tặng ${giftRule.rule.gift_qty}`);
        }

        if (giftRule.type === "advanced") {
          const handles = [
            ...new Set(giftRule.rule.listChilds.map((c) => c.handle)),
          ];

          handles.forEach((handle) => {
            const product = this.productCache[handle];
            if (!product) return;

            let quantity = 1;

            if (giftRule.rule.auto_add_gift) {
              quantity = giftRule.rule.gift_qty;
            } else {
              const child = giftRule.rule.listChilds.find(
                (c) => c.handle === handle
              );
              quantity = child?.quantity || 1;
            }

            parts.push(
              `tặng ${quantity}
                <a href="/${
                  locale === "en" ? `${locale}/` : ""
                }products/${handle}"
                    class="hover-text-link"
                    title="${product.title}">
                    ${product.title}
                </a>`
            );
          });
        }
      },
      renderHtml(messages) {},
    }));
  });
}
